import { PaginatedTariffsQueryVariables } from "@/graphql/__generated__/graphql";
import DateRangeFilter from "../../Shared/DateRangeFilter";
import { format } from "date-fns";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedTariffsQueryVariables) => void;
}

/**
 * TariffsActiveFromRange component for filtering tariffs by active from date range
 * @param props Component properties
 * @returns JSX element
 */
function TariffsActiveFromRange({ displayAmount, handleSubmitClick }: Props) {
  const tariffDateConfig = {
    paginationStateKey: "paginatedTariffs" as keyof PaginationState,
    dateFieldName: "activeFrom",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      dateRange: { gte: Date | null; lte: Date | null },
      sort?: any
    ): PaginatedTariffsQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: (dateRange.gte === null && dateRange.lte === null) ? null : {
          gte: dateRange.gte ? format(dateRange.gte, "yyyy-MM-dd") + "T00:00:00+00:00" : null,
          lte: dateRange.lte ? format(dateRange.lte, "yyyy-MM-dd") + "T23:59:59+00:00" : null,
        },
        province: filters.province || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      province: paginationState.filters?.province,
    })
  };

  return (
    <DateRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={tariffDateConfig}
    />
  );
}

export default TariffsActiveFromRange;
